<!-- Dialog: CANCEL TARDE CONFIRM  -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  appendTo="body"
  [resizable]="false"
  [closable]="true"
  [draggableDialog]="dialog"
  [modal]="true"
  [styleClass]="data.dialogData.class_name"
  (onHide)="closeDialog()"
>
  <p-header> {{title}} </p-header>
  <div>
    <p *ngIf="messages.length==1" [innerHTML]="messages[0]"></p>
    <p *ngIf="messages.length==1 && subMessage!=null">{{subMessage}}</p>

    <ul *ngIf="messages.length>1" class="fa-ul">
      <li *ngFor="let message of messages"><i class="fa-li fa icon-warning"></i>{{message}}</li>
    </ul>

    <p *ngIf="messages.length>1 && showConfirmationMessage">{{confirmationMessage}}</p>
    <p *ngIf="showLogoutMessage">Do you wish to exit the application?</p>
  </div>

  <p-footer fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="end center">
    <button
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="closeDialog()"
      label="No"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary"
      (click)="actionConfirmed()"
      label="Yes"
    ></button>
  </p-footer>
</p-dialog>
